module.exports = __webpack_public_path__ + "static/img/4_1_2.2b335971.jpg";